<ng-container *transloco="let translate">
  <eg-card-select
    [class.loading-search__destination]="locationType === 'destination'"
    [class.loading-search__start]="locationType === 'start'"
    [items]="this.groupedAddresses()"
    [searchPlaceholder]="translate('forms.locationSearch.input.placeholder')"
    [itemTemplate]="itemTemplate"
    [tileTemplate]="tileTemplate"
    [disabled]="control?.disabled || disabled"
    [hideAllItemsOnEmptyQuery]="false"
    (searchValueChange)="onSearchValueChanged($event)"
    (valueSelection)="onAddressSelect($event)"
    [keyboardNavigation]="false"
  >
  </eg-card-select>

  <ng-template #tileTemplate>
    <div fxFlex="44px" fxLayoutAlign="center center">
      @if (selectedImage) {
        <img [src]="selectedImage" class="mr-8" alt="SVG" />
      }
    </div>
    <div fxFlex="100" class="card-select__tile__content pl-16" fxLayout="column" fxLayoutAlign="center">
      <strong class="mt-8">{{ selectedAddress?.type ? translate('waypoints.' + selectedAddress?.type) : labelWithSuffix }}</strong>
      <p class="my-4">
        {{ selectedAddress?.formattedAddress || translate('forms.locationSearch.addressDefault') }}
      </p>
    </div>
  </ng-template>

  <ng-template #itemTemplate let-item="item" let-selectCallback="selectCallback">
    <div fxFlex="100" fxLayoutAlign="start center" class="px-16 mb-4 location-search__dropdown__group-label card-select__item-group">
      <img src="{{ baseUrlPath }}/assets/icons/waypoints/location_{{ item.type.toLowerCase() }}.svg" class="mr-8" alt="SVG" />
      <span>{{ translate('waypoints.' + item.type) }}</span>
    </div>
    @for (address of item.addresses; track address?.id ?? $index) {
      <div
        fxFlex="100"
        fxLayoutAlign="space-between center"
        class="px-16 location-search__dropdown__group__item card-select__item-group"
        (click)="selectCallback(address)"
      >
        <span>{{ address.formattedAddress }}</span>
        @if (enableFavorites && address?.street && !address?.favorite) {
          <eg-icon-button
            egBorderStyle="hidden"
            egButtonSize="small"
            icon="/assets/icons/star_empty.svg"
            class="mr-8"
            [egTooltip]="translate('forms.locationSearch.addFavorite')"
            (click)="addToFavorites(address, $event)"
          ></eg-icon-button>
        }
        @if (enableFavorites && address?.street && address?.favorite) {
          <eg-icon-button
            egBorderStyle="hidden"
            egButtonSize="small"
            icon="/assets/icons/star.svg"
            class="mr-8 star-filled"
            [egTooltip]="translate('forms.locationSearch.removeFavorite')"
            (click)="removeFromFavorites(address, $event)"
          ></eg-icon-button>
        }
      </div>
    }
  </ng-template>
</ng-container>
